import { useEffect, useState } from 'react'
import { Box, Progress, Stack } from '@chakra-ui/react'

import { File as CustomFile } from 'DigitalArchive/types'
import { UploadFile } from 'types'
import FileCard from 'DigitalArchive/components/FileCard'
import useUploadProgress from 'DigitalArchive/hooks/useUploadProgress'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import toast from 'utils/toast'
import { OpenEstaticFileButton, CustomDivider } from 'components'

type FormComponentProps = {
  questionKey: string
  currentFile: UploadFile
  fileArrayPositions?: [number, number, number]
}

export default function CustomFormFileCardToUploadFile({
  questionKey,
  currentFile,
  fileArrayPositions = [0, 1, 2],
}: FormComponentProps) {
  const [invalidFile, setInvalidFile] = useState<boolean>(false)

  const { formMethods, _uploadFile } = useCustomFormViewer()

  const { setUploadProgress, uploadProgress, onUploadProgress } = useUploadProgress()

  function setFileValuesOnForm(fileFromAPI: CustomFile) {
    const currentValues: (string | undefined)[] = formMethods.watch(questionKey) || []

    fileArrayPositions.forEach((number, index: number) => {
      if (index === 0) {
        currentValues[number] = fileFromAPI.id
      } else if (index === 1) {
        currentValues[number] = fileFromAPI.slug
      } else {
        currentValues[number] = fileFromAPI.archive_id
      }
    })

    return currentValues
  }

  async function uploadToAPI() {
    setUploadProgress(0)

    if (!_uploadFile) return
    const response = await _uploadFile({ file: currentFile.file as File, onUploadProgress })
    if (response?.header?.success) {
      setInvalidFile(false)
      const fileFromAPI = response?.body?.file
      if (fileFromAPI) {
        const fileValuesOnForm = setFileValuesOnForm(fileFromAPI)

        formMethods?.setValue(questionKey, fileValuesOnForm)
      } else {
        toast.error('Não foi retonado nenhum arquivo.')
      }
    } else {
      setInvalidFile(true)
    }
  }

  useEffect(() => {
    uploadToAPI()
  }, [currentFile])

  if (invalidFile) return null

  return (
    <FileCard className="" _hover={{}} hasMetadatas={false} key={currentFile.url} file={currentFile}>
      <Stack>
        <Box height="15px" width="100%" bg="transparent">
          <Progress colorScheme={uploadProgress === 100 ? 'green' : 'primary'} rounded="full" value={uploadProgress} />
        </Box>

        <CustomDivider />

        <OpenEstaticFileButton file={currentFile} />
      </Stack>
    </FileCard>
  )
}
